import {WlTree, WlTreeItem} from "./tree.component";

export * from './tree.component';
export default WlTreeItem;

customElements.define('wl-tree', WlTree);
customElements.define('wl-tree-item', WlTreeItem);